/* Campaign decoration only: no product, price, image or purchase changes. */
(() => {
  if (window.llnBlackNovemberLoaded) return;
  window.llnBlackNovemberLoaded = true;

  const root = document.documentElement;
  const groups = [
    ['.product-section .product-gallery-main', 'main'],
    ['lln-product-card.product-card[data-product-handle] .card-gallery', 'card'],
    ['.fh-category-grid > .fh-category', 'category'],
    ['.lln-standard-remover__media', 'companion']
  ];
  const excluded = '.product-thumbnails, .social-avatars, .lln-standard-remover__avatars, [data-black-november-exclude]';
  let pending = false;

  const visibleImage = (frame, kind) => {
    if (frame.closest(excluded)) return null;
    if (kind !== 'main') return frame.querySelector('img');

    const panels = Array.from(frame.children).filter(node =>
      node.matches('.product-media, [data-bundle-media], [data-ten-bundle-media]')
    );
    const active = panels.find(node => !node.hidden && node.getAttribute('aria-hidden') !== 'true');
    if (!active || active.querySelector('video, iframe, model-viewer')) return null;
    const hero = panels.find(panel => !panel.matches('[data-bundle-media], [data-ten-bundle-media]'));
    const isBundleHero = active.matches('[data-bundle-media], [data-ten-bundle-media]');
    if (active !== hero && !isBundleHero) return null;
    const image = active.querySelector('img');
    return image;
  };

  function update() {
    pending = false;
    const enabled = !!document.querySelector('header[data-black-november="true"]');
    root.classList.toggle('lln-black-november', enabled);
    if (!enabled) return;

    if (!document.querySelector('.lln-bn-ambient')) {
      const ambient = document.createElement('span');
      ambient.className = 'lln-bn-ambient';
      ambient.setAttribute('aria-hidden', 'true');
      document.body.append(ambient);
    }

    groups.forEach(([selector, kind]) => {
      document.querySelectorAll(selector).forEach(frame => {
        const image = visibleImage(frame, kind);
        let badge = Array.from(frame.children).find(node => node.classList.contains('lln-bn-badge'));
        if (!image && !badge) return;
        frame.classList.add('lln-bn-media', `lln-bn-media--${kind}`);
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'lln-bn-badge';
          badge.setAttribute('aria-hidden', 'true');
          frame.append(badge);
        }
        const label = 'Early Black Friday Sale';
        if (badge.textContent !== label) badge.textContent = label;
        if (badge.hidden !== !image) badge.hidden = !image;
      });
    });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }

  function start() {
    update();
    new MutationObserver(changes => {
      if (changes.some(change =>
        change.type === 'childList' ||
        change.attributeName === 'data-black-november' ||
        (change.attributeName === 'hidden' && change.target.closest('.product-gallery-main'))
      )) schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-black-november', 'hidden']
    });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();

